import { render } from "./pro-info.vue?vue&type=template&id=3c7185c2&scoped=true"
import script from "./pro-info.vue?vue&type=script&lang=js"
export * from "./pro-info.vue?vue&type=script&lang=js"

import "./pro-info.vue?vue&type=style&index=0&id=3c7185c2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3c7185c2"

export default script